export const filterSelector = state => state.filters;
